import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import {
  Badge,
  Col,
  Container,
  Row,
} from 'reactstrap';
import DataTable from '../../shared/components/DataTable';
import getMaterias from '../../redux/actions/subjectsActions';
import { fetchFormDatas } from '../../redux/actions/mallaActions';
import { createErrorMessage } from '../../helpers/notification';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import { tableFilters } from '../../helpers/storage';

const subjectsTableStorage = tableFilters('tblSubjects');

class SubjectsContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);

    const persistedData = subjectsTableStorage.get();

    this.state = {
      loading: true,
      page: persistedData.page || 1,
      pageSize: persistedData.pageSize || 25,
      totalItemsCount: 0,
      filters: persistedData.filters || {},
      items: [],
      mallas: [],
    };

    const options = [
      { value: 0, label: '-' },
      ...Array.from({ length: 10 }, (_, i) => ({
        value: i + 1,
        label: `${i + 1}º`,
      })),
    ];

    this.columns = ({ mallas }) => [
      {
        key: 'id',
        name: '#',
        search: false,
        width: '80px',
      },
      {
        key: 'codigo',
        name: 'Código',
        search: true,
      },
      {
        key: 'materia',
        name: 'Nombre',
        search: true,
      },
      {
        key: 'semestre',
        name: 'Semestre',
        format: ({ semestre }) => `${semestre}º`,
        search: true,
        type: 'select',
        searchProps: {
          options,
          isMulti: false,
        },
      },
      {
        visible: false,
        key: 'malla',
        name: 'Malla',
        search: true,
        type: 'select',
        searchProps: {
          options: mallas,
          isMulti: false,
        },
      },
      {
        key: 'correlativas',
        name: 'Correlativas',
        format: ({ correlativas }) => {
          const codigos = Array.isArray(correlativas) ? correlativas : [];

          if (!codigos.length) {
            return <Badge color="secondary">0</Badge>;
          }

          return (
            <div className="d-flex flex-wrap">
              {codigos.map(codigo => (
                <Badge key={codigo} color="info" className="mr-1 mb-1">{codigo}</Badge>
              ))}
            </div>
          );
        },
        search: false,
      },
      { key: 'actions', name: 'Acción', width: '85px' },
    ];
    this.actions = [
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Ver correlativas" />,
        callback: (materia) => {
          this.editMateria(materia);
        },
      },
    ];
  }

  componentDidMount() {
    this.refreshFormDatas();

    const { page, pageSize, filters } = this.state;
    this.loadMaterias(page, pageSize, filters);
  }

  refreshFormDatas = () => {
    this.setState({ loading: true });
    fetchFormDatas({
      onSuccess: ({
        mallas,
      }) => this.setState({
        loading: false,
        mallas,
      }),
      onError: () => {
        this.setState({
          loading: false,
          mallas: [],
        });
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  loadMaterias = (page, pageSize, filters = {}) => {
    this.setState({
      loading: true, page, pageSize, filters,
    });

    subjectsTableStorage.set({
      page,
      pageSize,
      filters,
    });

    getMaterias({
      pageInfo: {
        page,
        pageSize,
        filters,
      },
      onSuccess: (items) => {
        this.setState({
          loading: false,
          items: Array.isArray(items && items.items) ? items.items : [],
          totalItemsCount: items && items.totalItemsCount ? items.totalItemsCount : 0,
        });
      },
      onError: () => {
        this.setState({ loading: false, items: [], totalItemsCount: 0 });
        createErrorMessage('Error al intentar cargar la lista de materias');
      },
    });
  }

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.loadMaterias(page, pageSize, filters);
    }
  }

  onDataTableSubmit = (values) => {
    const { pageSize } = this.state;
    this.loadMaterias(1, pageSize, values || {});
  }

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.loadMaterias(1, pageSize, {});
  }

  editMateria = (materia) => {
    const { history } = this.props;
    history.push(`/pages/subjects/edit/${materia.id}`);
  };

  getGridActions = (key) => {
    const actions = { actions: this.actions };
    return actions[key];
  }

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
      mallas,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Materias y Correlativas</h3>
            <h3 className="page-subhead subhead">
              Listado de materias y gestión de correlativas
            </h3>
          </Col>
        </Row>
        <Row>
          {loading
            ? <Col md={12}><LoadingSpinner /></Col>
            : (
              <DataTable
                title="Listado de materias"
                columns={this.columns({ mallas })}
                items={items}
                onChangePage={this.onChangePage}
                page={page}
                pageSize={pageSize}
                totalItemsCount={totalItemsCount}
                getGridActions={key => this.getGridActions(key)}
                onSubmit={this.onDataTableSubmit}
                onClearFilters={this.onDataTableClearFilters}
                initialValues={filters}
                enableReinitialize
              />
            )
          }
        </Row>
      </Container>
    );
  }
}

export default withRouter(SubjectsContainer);
